define(["require", "exports", "./modules/services/toastNotification", "./modules/utils/userCredentials", "./modules/components/togglePassword"], function (require, exports, toastNotification_1, userCredentials_1, togglePassword_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var notificationMs = 4000;
    var txtUsername = document.querySelector("#txtUsername");
    var txtPassword = document.querySelector("#txtPassword");
    var btnLogin = document.querySelector("#btnLogin");
    var disabledClassesForButton = ['bg-linx-purple-transparent-100', 'text-white', 'cursor-not-allowed'];
    var enabledClassesForButton = ['bg-linx-purple-1100', 'text-white', 'cursor-pointer', 'border-linx-purple-1100', 'hover:border-linx-purple-1200', 'hover:bg-linx-purple-1200'];
    var onLoginLoad = function () {
        if (!txtUsername || !txtPassword)
            return;
        tryEnableLogin();
        togglePassword_1.togglePasswordVisibility();
        txtUsername.focus();
        txtUsername.select();
        txtUsername.addEventListener('focusout', onUsernameFocusOut);
        txtPassword.addEventListener('focusout', onPasswordFocusOut);
        Array.from([txtUsername, txtPassword]).forEach(function (elem) { return elem.addEventListener('keyup', tryEnableLogin); });
    };
    var onUsernameFocusOut = function () {
        var validUsername = userCredentials_1.isUsernameValid(this.value);
        if (!validUsername) {
            if (this.value.length > 0)
                toastNotification_1.ToastNotification.Error('Usuário ou e-mail inválido, por favor informe ao menos 4 caracteres', notificationMs);
            enableLogin(false);
            return;
        }
    };
    var onPasswordFocusOut = function () {
        var validPassword = userCredentials_1.isPasswordValid(this.value);
        if (!validPassword) {
            if (this.value.length > 0)
                toastNotification_1.ToastNotification.Error('Senha inválida, por favor informe ao menos 8 caracteres', notificationMs);
            enableLogin(false);
            return;
        }
    };
    var enableLogin = function (enable) {
        var _a, _b, _c, _d;
        if (!btnLogin)
            return;
        if (enable) {
            (_a = btnLogin.classList).remove.apply(_a, disabledClassesForButton);
            (_b = btnLogin.classList).add.apply(_b, enabledClassesForButton);
            btnLogin.removeAttribute('disabled');
        }
        else {
            (_c = btnLogin.classList).remove.apply(_c, enabledClassesForButton);
            (_d = btnLogin.classList).add.apply(_d, disabledClassesForButton);
            btnLogin.setAttribute('disabled', 'disabled');
        }
        btnLogin.disabled = !enable;
    };
    var tryEnableLogin = function () {
        if (!txtUsername || !txtPassword) {
            enableLogin(false);
            return;
        }
        var enable = userCredentials_1.isUsernameValid(txtUsername.value) && userCredentials_1.isPasswordValid(txtPassword.value);
        enableLogin(enable);
    };
    window.addEventListener('load', onLoginLoad);
});
